// Dates in the active Elakay language (header language selector), never in the browser's own
// language: relative times ("a day ago") through the moment.js already used by the order pages,
// absolute dates through Intl with the same locale as elakayIntlLocale().
import moment from "moment";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/pt-br";
import { elakayIntlLocale, getElakayLanguageCode } from "../includes/pageInside/dataElakay";

// moment ships no Haitian Creole locale.
if (!moment.locales().includes("ht")) {
  moment.defineLocale("ht", {
    parentLocale: "fr",
    months: "janvye_fevriye_mas_avril_me_jen_jiyè_out_septanm_oktòb_novanm_desanm".split("_"),
    monthsShort: "jan._fev._mas_avr._me_jen_jiy._out_sept._okt._nov._des.".split("_"),
    weekdays: "dimanch_lendi_madi_mèkredi_jedi_vandredi_samdi".split("_"),
    weekdaysShort: "dim._len._mad._mèk._jed._van._sam.".split("_"),
    weekdaysMin: "di_le_ma_mè_je_va_sa".split("_"),
    relativeTime: {
      future: "nan %s",
      past: "sa gen %s",
      s: "kèk segonn",
      ss: "%d segonn",
      m: "yon minit",
      mm: "%d minit",
      h: "inèdtan",
      hh: "%d èdtan",
      d: "yon jou",
      dd: "%d jou",
      w: "yon semèn",
      ww: "%d semèn",
      M: "yon mwa",
      MM: "%d mwa",
      y: "yon ane",
      yy: "%d ane",
    },
  });
}
// Importing/defining a locale switches moment's GLOBAL locale; keep the global default English so
// no other screen changes behaviour, and localize per call below.
moment.locale("en");

const MOMENT_LOCALES = { en: "en", es: "es", fr: "fr", ht: "ht", pt: "pt-br" };

export const elakayMoment = (value) => moment(value).locale(MOMENT_LOCALES[getElakayLanguageCode()] || "en");

// "a day ago" / "il y a un jour" / "hace un día" / "sa gen yon jou" / "há um dia"
export const elakayFromNow = (value) => (value ? elakayMoment(value).fromNow() : "");

const toDate = (value) => {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatElakayDate = (value, options = { year: "numeric", month: "short", day: "numeric" }) => {
  const d = toDate(value);
  if (!d) return "";
  try { return d.toLocaleDateString(elakayIntlLocale(), options); } catch { return d.toLocaleDateString(); }
};

export const formatElakayDateTime = (value, options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) => {
  const d = toDate(value);
  if (!d) return "";
  try { return d.toLocaleString(elakayIntlLocale(), options); } catch { return d.toLocaleString(); }
};

export const formatElakayTime = (value, options = undefined) => {
  const d = toDate(value);
  if (!d) return "";
  try { return d.toLocaleTimeString(elakayIntlLocale(), options); } catch { return d.toLocaleTimeString(); }
};

export const formatElakayNumber = (value, options = undefined) => {
  try { return new Intl.NumberFormat(elakayIntlLocale(), options).format(Number(value) || 0); } catch { return String(Number(value) || 0); }
};
